export default "__VITE_ASSET__OM8UbcRn__"